// Configuration for Endodontic Table rows, should be similar to the WEB one

export type TableRowConfig = {
  rowIndex: number
  key: string // Unique key for this row (e.g., "probing_vestibular", "mobility")
  groupTitle?: string // Group title that can span multiple rows (e.g., "Probing")
  groupTitleRowSpan?: number // Row span for group title
  title: string // Row title
  titleColSpan: number // Column span for row title
  columnsPerTooth: number // How many input columns per tooth (e.g., 3 for probing, 1 for cold test)
  cellColSpan?: number // If cells span multiple columns (e.g., 3 for cold test)
}

// Column count - titles are now editable and stored in JSON data
export const ENDODONTIC_TABLE_COLUMN_COUNT = 5

// Column indices for iteration
export const ENDODONTIC_TABLE_COLUMNS = [0, 1, 2, 3, 4]

export const ENDODONTIC_TABLE_ROWS: TableRowConfig[] = [
  {
    rowIndex: 0,
    key: 'probing_vestibular',
    groupTitle: 'Probing',
    groupTitleRowSpan: 2,
    title: 'Vestibular',
    titleColSpan: 1,
    columnsPerTooth: 3,
  },
  {
    rowIndex: 1,
    key: 'probing_lingual',
    title: 'Lingual',
    titleColSpan: 1,
    columnsPerTooth: 3,
  },
  {
    rowIndex: 2,
    key: 'mobility',
    title: 'Mobility',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 3,
    key: 'percussion',
    title: 'Percussion',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 4,
    key: 'palpation',
    title: 'Palpation',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 5,
    key: 'cold_test',
    title: 'Cold Test',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 6,
    key: 'electric_pulp_test',
    title: 'Electric Pulp Test',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 7,
    key: 'bite_test',
    title: 'Bite Test',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 8,
    key: 'heat_test',
    title: 'Heat Test',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
  {
    rowIndex: 9,
    key: 'discolouration',
    title: 'Discolouration',
    titleColSpan: 2,
    columnsPerTooth: 1,
    cellColSpan: 3,
  },
]

// Helper to get column title key
export const getColumnTitleKey = (columnIndex: number): string => `column_title_${columnIndex}`

// Helper to generate cell key: "{rowKey}_{columnIndex}_{cellIndex}"
export const getCellKey = (rowKey: string, columnIndex: number, cellIndex: number): string =>
  `${rowKey}_${columnIndex}_${cellIndex}`

// Helper to get all cell keys for a row
export const getRowCellKeys = (config: TableRowConfig): string[] => {
  const keys: string[] = []
  ENDODONTIC_TABLE_COLUMNS.forEach((columnIndex) => {
    for (let cellIndex = 0; cellIndex < config.columnsPerTooth; cellIndex++) {
      keys.push(getCellKey(config.key, columnIndex, cellIndex))
    }
  })
  return keys
}

export const MIN_TABLE_WIDTH = 1200 // px
